import {DialogService} from "primeng/dynamicdialog";

let patched = false;

/**
 * Normalizes DynamicDialog defaults app-wide so every `dialogService.open()` gets
 * consistent behaviour without repeating boilerplate. Each default is applied only
 * when the caller left it undefined, so explicit per-dialog values (e.g. the few
 * `draggable: false` dialogs) still win.
 *
 * Defaults: `dismissableMask`, `modal` and `draggable` (all universal across the
 * app's call sites). `width` is intentionally NOT defaulted — it is genuinely
 * per-dialog (vw fractions, px, rem) and must stay on the call site.
 */
export function patchDynamicDialogDefaults(): void {
    if (patched) return;
    patched = true;
    const proto = DialogService.prototype as any;
    const orig = proto.open;
    proto.open = function (componentType: unknown, config: any) {
        const next = {...(config ?? {})};
        if (next.dismissableMask === undefined) next.dismissableMask = true;
        if (next.modal === undefined) next.modal = true;
        if (next.draggable === undefined) next.draggable = true;
        return orig.call(this, componentType, next);
    };
}
